// import React from 'react'
import {QueryClient, QueryClientProvider, useMutation, useQuery} from 'react-query'

export {QueryClient, QueryClientProvider, useMutation, useQuery}
